import { useCallback } from "react";
import { Button, InputGroup } from "@blueprintjs/core";
import type { Table } from "@tanstack/react-table";
import { TablePagination, PaginationSelect } from "./Styles";
import { pageSizeOptions } from "@/config";

interface IPaginationProps {
  table: Table<any>;
  totalSize?: number;
}
const Pagination = ({ table, totalSize }: IPaginationProps) => {
  const { getPageCount, setPageIndex } = table;
  const handleSetPageIndex = useCallback(
    (input: HTMLInputElement) => {
      const value = input.value;
      const page = value ? Number(value) - 1 : 0;
      const count = getPageCount() - 1;
      setPageIndex(page > count ? (count > 0 ? count : 0) : page);
    },
    [getPageCount, setPageIndex]
  );
  return (
    <TablePagination>
      <Button
        small
        icon="double-chevron-left"
        onClick={table.setPageIndex.bind(this, 0)}
        disabled={!table.getCanPreviousPage()}
      />
      <Button
        small
        icon="caret-left"
        onClick={table.previousPage}
        disabled={!table.getCanPreviousPage()}
      >
        上一页
      </Button>
      <span className="flex items-center min-w-16 justify-center">
        {table.getState().pagination.pageIndex + 1} / {table.getPageCount()}
      </span>
      <Button
        small
        rightIcon="caret-right"
        onClick={table.nextPage}
        disabled={!table.getCanNextPage()}
      >
        下一页
      </Button>
      <Button
        small
        icon="double-chevron-right"
        onClick={table.setPageIndex.bind(this, table.getPageCount() - 1)}
        disabled={!table.getCanNextPage()}
      />
      {!!totalSize && <div>共 {totalSize} 条</div>}
      <PaginationSelect
        value={table.getState().pagination.pageSize}
        onChange={(e) => {
          table.setPageSize(Number(e.target.value));
        }}
      >
        {pageSizeOptions.map((pageSize) => (
          <option key={pageSize} value={pageSize}>
            {pageSize} 条/页
          </option>
        ))}
      </PaginationSelect>
      <div className="flex items-center gap-1">
        跳至
        <InputGroup
          small
          size={4}
          defaultValue={`${table.getState().pagination.pageIndex + 1}`}
          onBlur={(e) => handleSetPageIndex(e.target)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSetPageIndex(e.currentTarget);
            }
          }}
        />
        页
      </div>
    </TablePagination>
  );
};

export default Pagination;
